export default __webpack_public_path__ + "static/media/deletesh.5ea59f70.svg";